import React from 'react'
import Button from '@mui/material/Button'
import RefreshIcon from '@mui/icons-material/Refresh'
import { Header, Title } from '../styles'

const DashboardHeader = ({ onRefresh }) => (
  <Header>
    <Title variant="h4">Billing Dashboard</Title>
    <Button
      variant="outlined"
      startIcon={<RefreshIcon />}
      onClick={onRefresh}
      sx={{ borderRadius: 2 }}
    >
      Refresh
    </Button>
  </Header>
)

export default DashboardHeader
